import { CampaignAlert, GraphQLAlertMetric } from 'modules/campaigns/alerts/types';
import { createContext, useContext } from 'react';
import { DefaultValues } from 'react-hook-form';
import noop from 'utils/noop';

export interface AlertOverridesContextState {
  metrics: GraphQLAlertMetric[];
  defaultValues: DefaultValues<Record<string, unknown>> | undefined;
  isLoadingOverrides: boolean;
  projectDefaultValues: DefaultValues<Record<string, unknown>> | undefined;
  campaignAlerts: CampaignAlert[];
  refetchCampaignAlerts: () => void;
}

export const DEFAULT_ALERT_OVERRIDES_CONTEXT_STATE: AlertOverridesContextState = {
  defaultValues: {},
  metrics: [],
  isLoadingOverrides: false,
  projectDefaultValues: {},
  campaignAlerts: [],
  refetchCampaignAlerts: noop,
};

export const AlertOverridesContext = createContext<AlertOverridesContextState>(
  DEFAULT_ALERT_OVERRIDES_CONTEXT_STATE,
);

export const useAlertOverridesContext = () => useContext(AlertOverridesContext);
